export const experienceData = [
  {
    id: 1,
    company: "Ravant Media",
    jobtitle: "Full Stack Engineer",
    startYear: "Aug 2025",
    endYear: "Oct 2025",
    description: [
      "Created and maintained a crypto presale platform using Next.js, Wagmi, and EVM-compatible smart contracts, supporting 1K+ daily users and processing ~$100K in daily transactions",
      "Consolidated cross-chain swap APIs and a multi-chain webhook enabling smooth asset transfers between EVM and Solana networks",
      "Pioneered a cloud-based media processing pipeline on GCP using Cloud Functions, GCS, and Whisper Large v3, automating video-to-audio conversion, chunking, and transcription with data stored in PostgreSQL",
    ],
    technologies:
      "Next.js, Nest.js, PostgreSQL, Socket.IO, Java, WalletConnect v2, Web3.js, Solana Web3.js, GCP (Cloud Functions, Cloud Storage, Cloud SQL, Model Garden), Whisper Large v3, Docker, Railway",
  },
  {
    id: 2,
    company: "The Narayana Group",
    jobtitle: "Senior Software Engineer",
    startYear: "Feb 2025",
    endYear: "Jul 2025",
    description: [
      "Built cost-effective AI transcription system using Vertex AI (₹0.28/90s call)",
      "Architected 20-parameter analytics framework processing millions of calls",
      "Created production-ready RAG chatbot with Gemini-2.0-flash",
    ],
    technologies:
      ".NET, Python, JS, PostgreSQL, GCP, Vertex AI, LLMs, Prompt Engineering, ReactJS, NodeJS",
  },
  {
    id: 3,
    company: "Stigen Martech Private Limited",
    jobtitle: "Software Development Engineer",
    startYear: "Jun 2023",
    endYear: "Jan 2025",
    description: [
      "Engineered 6 full-stack web applications, increasing operational efficiency by 40%",
      "Developed 2 React Native apps serving 50K+ users",
      "Led Spinotale development achieving 90% performance boost through architecture optimization",
    ],
    technologies:
      "React, React-Native, NextJS, NodeJS, NestJS, PostgreSQL, GCP, socket.io, LLMs",
  },
  {
    id: 4,
    company: "StrategyWerks",
    jobtitle: "Software Development Engineer - 1",
    startYear: "Nov 2022",
    endYear: "May 2023",
    description: [
      "Built 5 full-stack applications from scratch",
      "Implemented AWS Lambda serverless architecture, reducing server costs by 30%",
      "Collaborated on re-architecting workflows achieving 70% performance boost",
    ],
    technologies:
      "React, Next.JS, React-Native, Angular, Nest.JS, Node.JS, PostgreSQL, AWS, GPT-3.5",
  },
  {
    id: 5,
    company: "Masai School",
    jobtitle: "Instructional Associate",
    startYear: "Feb 2022",
    endYear: "Oct 2022",
    description: [
      "Mentored 150+ students to become professional web developers",
      "Implemented 3 real-world full-stack applications for 600+ learners, teaching frontend-backend integration and deployment",
    ],
    technologies: "React, Next.JS, Node.JS, Heroku",
  },
];
